var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-date-picker',{attrs:{"format":"YYYY-MM-DD HH:mm:ss","disabled-date":_vm.disabledDate,"disabled-time":_vm.disabledDateTime,"show-time":{ defaultValue: _vm.moment('00:00:00', 'HH:mm:ss') }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }